"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoadingOverlay = void 0;
var _mui = require("@ori-ui/mui");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const LoadingBackdrop = (0, _mui.styled)(_mui.Backdrop)((param)=>{
    let { theme } = param;
    return {
        background: (0, _mui.alpha)(theme.palette.background.paper, 0.9),
        display: 'grid',
        alignContent: 'center',
        justifyContent: 'center'
    };
});
const LoadingOverlay = ()=>{
    const { loadingItem } = (0, _contexts.useBasketContext)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    if (loadingItem > 0) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Backdrop, {
            invisible: true,
            open: true
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadingBackdrop, {
        open: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.CircularProgress, {
            "aria-label": formatMessage('loading')
        })
    });
};
exports.LoadingOverlay = LoadingOverlay;
